import { zoneStore, syncQueue, idMapStore } from '../indexedDBService'
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export async function syncZones() {
	const keys = await syncQueue.keys()

	for (const key of keys) {
		const action = await syncQueue.getItem(key)

		if (!action || !action.type) continue

		try {
			if (action.type === 'ZONE_ADD_OFFLINE') {
				if (action.payload?.zone?.length > 20) {
					const resolved = await idMapStore.getItem(action.payload.zone)
					if (resolved) action.payload.zone = resolved
				}

				const { data, status } = await Axios.post('/api/zone/register', action.payload, {
					headers: { auth: localStorage.getItem('jwt') }
				})
				if (status === 200 && data?.zone?._id) {
					await idMapStore.setItem(key, data.zone._id)
					await syncQueue.removeItem(key)
					await zoneStore.removeItem(key)
				}
			}

			if (action.type === 'ZONE_EDIT_OFFLINE') {
				if (action.payload?.zone?.length > 20) {
					const resolved = await idMapStore.getItem(action.payload.zone)
					if (resolved) action.payload.zone = resolved
				}

				const { data, status } = await Axios.put(`/api/zone/edit/${key}`, action.payload, {
					headers: { auth: localStorage.getItem('jwt') }
				})
				if (status === 200 || status === 264) {
					await syncQueue.removeItem(key)
					await zoneStore.removeItem(key)
				}
			}
		} catch (error) {
			console.warn('Error al sincronizar zona offline:', error)
		}
	}
}
